import React, { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
type HeroSlide = {
  eyebrow: string;
  title: string;
  description: string;
  primaryLabel: string;
  primaryTo: string;
  secondaryLabel?: string;
  secondaryTo?: string;
  background: string;
  mobilePosition: string;
  desktopPosition: string;
};
const slides: HeroSlide[] = [{
  eyebrow: '6GTOOLS.COM',
  title: 'Industrial Supply of Metal Cutting Tools',
  description: 'Shop end mills, drill bits, thread mills, carbide burrs, reamers, and metalworking fluids from leading USA cutting tool brands.',
  primaryLabel: 'Browse Cutting Tools',
  primaryTo: '/category-template',
  secondaryLabel: 'Speeds & Feeds Calculator',
  secondaryTo: '/technical-info/end-mills/feeds-and-speeds-calculator',
  background: 'https://cdn.magicpatterns.com/uploads/5Ngr8wmRU2Wquv2bHdYZzR/6gtools-general-hero.webp',
  mobilePosition: '70% center',
  desktopPosition: 'center center'
}, {
  eyebrow: 'FEATURED SUPPLIER',
  title: 'TITAN USA Cutting Tools',
  description: 'Milling, micro milling, carbide deburring, drilling, reaming, thread milling, and tapping tools backed by strong inventory and service.',
  primaryLabel: 'Shop TITAN Tools',
  primaryTo: '/category-template',
  background: 'https://cdn.magicpatterns.com/uploads/8eL4PemcidN4fsYWN58t2A/6gtools-titan-hero.webp',
  mobilePosition: '68% center',
  desktopPosition: 'center center'
}, {
  eyebrow: 'FEATURED SUPPLIER',
  title: 'M.A. Ford High Performance Cutting Tools',
  description: 'High quality milling, drilling, and deburring tools with strong inventory control and customer service.',
  primaryLabel: 'Browse M.A. Ford Tools',
  primaryTo: '/category-template',
  background: 'https://cdn.magicpatterns.com/uploads/9RMdDhxirHunvNSeRCp2Uv/6gtools-maford-hero.webp',
  mobilePosition: '67% center',
  desktopPosition: 'center center'
}];
export function HomeHero() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const activeSlide = slides[activeIndex];
  useEffect(() => {
    if (paused) return undefined;
    const timer = window.setInterval(() => setActiveIndex(index => (index + 1) % slides.length), 5500);
    return () => window.clearInterval(timer);
  }, [paused]);
  const showPrevious = () => setActiveIndex(index => (index - 1 + slides.length) % slides.length);
  const showNext = () => setActiveIndex(index => (index + 1) % slides.length);
  return <section className="relative isolate h-[520px] overflow-hidden bg-brand-charcoal sm:h-[480px] md:h-[500px]" aria-label="Featured tools and suppliers" onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)} data-id="element-435" data-mp="1wlhw2fu041k2">
      <div key={activeSlide.background} className="hero-fade absolute inset-0" data-id="element-436" data-mp="3cx57eusl2ila">
        <img src={activeSlide.background} alt="" className="hero-image-position h-full w-full object-cover" style={{
        '--mobile-position': activeSlide.mobilePosition,
        '--desktop-position': activeSlide.desktopPosition
      } as React.CSSProperties} data-id="element-437" data-mp="3hvyjcis821jc" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0d141b]/95 via-[#0d141b]/77 to-[#0d141b]/18 sm:from-[#0d141b]/88 sm:via-[#0d141b]/58 sm:to-transparent" data-id="element-438" data-mp="wj3281ojhths" />
      </div>

      <div key={`content-${activeIndex}`} className="hero-fade relative mx-auto flex h-full max-w-7xl items-center px-12 py-16 sm:px-16 md:px-20 lg:px-4" data-id="element-439" data-mp="mlf5553go9wg">
        <div className="max-w-xl text-white md:ml-12" data-id="element-440" data-mp="iiscx32vomyq">
          <p className="text-sm font-bold tracking-[0.18em] text-brand-lightGold" data-id="element-441" data-mp="dk7b4z7z9v86">{activeSlide.eyebrow}</p>
          <div className="mt-4 text-4xl font-bold leading-tight sm:text-5xl" data-id="element-442" data-mp="8mxotsfvxzok">{activeSlide.title}</div>
          <p className="mt-5 max-w-lg text-base leading-7 text-gray-100 sm:text-lg" data-id="element-443" data-mp="27xyrsioq5fd4">{activeSlide.description}</p>
          <div className="mt-7 flex flex-wrap gap-3" data-id="element-444" data-mp="2318cvyonopta">
            <Link to={activeSlide.primaryTo} className="inline-flex items-center justify-center rounded-md border border-brand-darkGold bg-brand-lightGold px-5 py-3 text-sm font-bold text-black transition-colors hover:bg-brand-darkGold" data-id="element-445" data-mp="10msdi9qbu8ja">{activeSlide.primaryLabel}</Link>
            {activeSlide.secondaryLabel && activeSlide.secondaryTo && <Link to={activeSlide.secondaryTo} className="inline-flex items-center justify-center rounded-md border border-white/70 bg-black/20 px-5 py-3 text-sm font-bold text-white transition-colors hover:bg-white hover:text-brand-charcoal" data-id="element-446" data-mp="vmd2hotipd4h">{activeSlide.secondaryLabel}</Link>}
          </div>
        </div>
      </div>

      <button type="button" onClick={showPrevious} aria-label="Previous slide" className="absolute left-3 top-1/2 -translate-y-1/2 rounded-full border border-white/60 bg-black/30 p-2 text-white transition-colors hover:bg-white hover:text-brand-charcoal sm:left-5" data-id="element-447" data-mp="7zenkvl1qd8o"><ChevronLeft className="h-5 w-5" data-id="element-448" data-mp="2za5x28ejcgv" /></button>
      <button type="button" onClick={showNext} aria-label="Next slide" className="absolute right-3 top-1/2 -translate-y-1/2 rounded-full border border-white/60 bg-black/30 p-2 text-white transition-colors hover:bg-white hover:text-brand-charcoal sm:right-5" data-id="element-449" data-mp="2xz2x4ms68qt"><ChevronRight className="h-5 w-5" data-id="element-450" data-mp="3ph23wym76dza" /></button>
      <div className="absolute bottom-5 left-1/2 flex -translate-x-1/2 gap-2" data-id="element-451" data-mp="3phu28h76ipt9">
        {slides.map((slide, index) => <button key={slide.title} type="button" onClick={() => setActiveIndex(index)} aria-label={`Show ${slide.title}`} aria-current={index === activeIndex} className={`h-2.5 rounded-full transition-all ${index === activeIndex ? 'w-7 bg-brand-lightGold' : 'w-2.5 bg-white/60 hover:bg-white'}`} data-id="element-452" data-mp="3kjir8355e99g" data-mpi={index} />)}
      </div>
    </section>;
}